import React from "react";
import Footer from "./Footer";
import './Know_Me.css';
import About from './about.jpg';
import { NavLink } from "react-router-dom";
import Photo from "./Shubhra_Srivastava.jpg";
import Contact from "./Contact";
import { Link } from "react-scroll";

const KnowME =()=>{
    return<>
    <section>
    <div className="container-fluid">
    <div className="row">
    <nav className="navbar"> 
            {/* <div className="logo"><img src={Logo} alt="React" className="logo"/></div> */}
            
                <ul className="nav-links">
                    <input type="checkbox" id="checkbox_toggle"/>
                    <label for="checkbox_toggle" className="hamburger">&#9776;</label>
                    <div className="menu_know">
                    <li className="nav-item active"><a href="#" className="nav-link font-italic"><NavLink to="/" className="NavLink">Home</NavLink></a></li>
                    <li className="nav-item active"><a href="#" className="nav-link font-italic"><Link to="know-me" spy={true} smooth={true} offset={50} duration={350} className="link" >About</Link></a></li>
                    <li className="nav-item active"><a href="#" className="nav-link font-italic"><Link to="skills" spy={true} smooth={true} offset={50} duration={350} className="link">Skills</Link> </a></li>
                    <li className="nav-item active"><a href="#" className="nav-link font-italic"><Link to="contact" spy={true} smooth={true} offset={50} duration={350} className="link" > Contact</Link></a></li>
                    </div>
                </ul>
            
        </nav>
    {/* <nav className="navbar navbar-expand-lg navbar-light bg-light py-3">
    <button type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span></button>
    <div id="navbarSupportedContent" className="collapse navbar-collapse">
      <ul className="navbar-nav ml-auto about-nav">
        <li className="nav-item active"><a href="#" className="nav-link font-italic"><NavLink to="/" className="NavLink">Home</NavLink></a></li>
        <li className="nav-item active"><a href="#" className="nav-link font-italic"><NavLink to="know-me" className="NavLink">About</NavLink></a></li>
        <li className="nav-item active"><a href="#" className="nav-link font-italic"> <Link to="skills" spy={true} smooth={true} offset={50} duration={350} >Skills</Link> </a></li>
        <li className="nav-item active"><a href="#" className="nav-link font-italic"><Link to="contact" spy={true} smooth={true} offset={50} duration={350} > Contact</Link></a></li>
      </ul>
    </div>
  {/* </div> 
</nav> */}

<div className="bg-light" id="know-me">
  <div className="container py-5">
    <div className="row h-100 align-items-center py-5">
      <div className="col-lg-6" >
        <h1 className="display-4">Shubhra Srivastava</h1>
        <p className="lead text-muted mb-0">Software Developer</p>
      </div>
      <div className="col-lg-6 d-none d-lg-block photo"><img src={Photo} alt="" className="img-fluid"/></div>
    </div>
  </div>
</div>

<div className="bg-white py-5">
  <div className="container py-5">
    <div className="row align-items-center mb-5">
      <div className="col-lg-6 order-2 order-lg-1"><i className="fa fa-bar-chart fa-2x mb-3  bar"></i>
        <h2 className="font-weight-light">About ME</h2>
        <p className="font-italic text-muted mb-4">Welcome to my extraordinary portfolio! I am a passionate Software Developer with a keen eye for aesthetics and a dedication to creating user-centric designs.

Get ready to explore a collection of captivating websites that seamlessly blend creativity and functionality. Each project I undertake is an opportunity to craft immersive experiences that leave a lasting impression on users.

Join me on this exciting digital journey, where innovation meets elegance, and technology merges with art. Together, we can make your online presence truly remarkable and unforgettable. Feel free to reach out, and let's collaborate to create a website that sets new standards of excellence.</p>
      </div>
      <div className="col-lg-5 px-5 mx-auto order-1 order-lg-2" id="skills"><img src="https://bootstrapious.com/i/snippets/sn-about/img-1.jpg" alt="" className="img-fluid mb-4 mb-lg-0"/></div>
    </div>
    <div className="row align-items-center">
      <div className="col-lg-5 px-5 mx-auto"><img src="https://bootstrapious.com/i/snippets/sn-about/img-2.jpg" alt="" className="img-fluid mb-4 mb-lg-0"/></div>
      <div className="col-lg-6"><i className="fa fa-leaf fa-2x mb-3 bar"></i>
        <h2 className="font-weight-light">SKILLS</h2>
        <div className="row tiles">
        <div className="col-2 pb-2"><button type="button" className="btn skill">MERN STACK</button></div>
<div className="col-2 pb-2"><button type="button" className="btn skill">JAVASCRIPT</button></div>
<div className="col-2 pb-2"><button type="button" className="btn skill">PYTHON </button></div>
<div className="col-2 pb-2"><button type="button" className="btn skill">MONGODB
</button></div>
<div className="col-2 pb-2"><button type="button" className="btn skill">MY SQL 
</button></div>
<div className="col-2 pb-2"><button type="button" className="btn skill">REACT.JS
</button></div>
<div className="col-2 pb-2"><button type="button" className="btn skill">NODE.JS 
</button></div>
<div className="col-2 pb-2"><button type="button" className="btn skill">HTML 5 
  {/* <span className="badge badge-light">9</span>
  <span className="sr-only">unread messages</span> */}
</button></div>
<div className="col-2 pb-2"><button type="button" className="btn skill">CSS
  {/* <span className="badge badge-light">9</span>
  <span className="sr-only">unread messages</span> */}
</button></div>
<div className="col-2 pb-2"><button type="button" className="btn skill">GIT 
  {/* <span className="badge badge-light">9</span>
  <span className="sr-only">unread messages</span> */}
</button></div>
<div className="col-2 pb-2"><button type="button" className="btn skill">C 
  {/* <span className="badge badge-light">9</span>
  <span className="sr-only">unread messages</span> */}
</button></div>
<div className="col-2 pb-2"><button type="button" className="btn skill">OPERATING SYSTEM 
  {/* <span className="badge badge-light">9</span>
  <span className="sr-only">unread messages</span> */}
</button></div>
</div>
      </div>
    </div>
  </div>
</div>

<Contact/>



        </div>
    </div>
    
    </section>
    <Footer/>
    </>
}

export default KnowME;